const WORDS = [
  "Monaco",
  "Mayfair",
  "Dubai",
  "New York",
  "Singapore",
  "Saint-Tropez",
  "Aspen",
  "Geneva",
  "Lake Como",
  "Courchevel",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[rgba(200,164,93,0.14)] bg-[#080808] py-6"
    aria-hidden="true"
  >
    <div className="animate-lux-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {WORDS.map((w) => (
            <span key={`${w}-${dup}`} className="flex items-center">
              <span className="whitespace-nowrap px-9 font-serif text-xl font-light italic tracking-wide text-ivory/60">
                {w}
              </span>
              <span className="h-[5px] w-[5px] rotate-45 border border-champagne/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
